export const credentialTableColumns = [
  {
    key: "role",
    display_name: "Role Access",
    cellStyles: {
      "font-size": "13px",
    },
    headerStyles: {
      background: "#7593F2",
      "font-weight": "600",
      width: "20%",
      borderRadius: "6px 0 0",
      color: "#fff",
    },
    _editConfig: {
      type: 'input',
      placeholder: 'Enter role access'
    }
  },
  {
    key: "username",
    display_name: "Username/ Email",
    cellStyles: { "font-size": "13px" },
    headerStyles: {
      background: "#7593F2",
      "font-weight": "600",
      width: "20%",
      color: "#fff",
    },
    _editConfig: {
      type: 'input',
      placeholder: 'Enter username/email'
    }
  },
  {
    key: "password",
    display_name: "Password",
    cellStyles: { "font-size": "13px" },
    headerStyles: {
      background: "#7593F2",
      color: "#fff",
      width: "20%",
      "font-weight": "600",
    },
    _config: {
      type: 'password',
      classNames: 'border-0 bg-transparent'
    },
    _editConfig: {
      type: 'password',
      placeholder: 'Enter password',
      classNames: 'border-1 bg-white'
    }
  },
  {
    key: "remarks",
    display_name: "Remarks/ Comments",
    cellStyles: { "font-size": "13px" },
    headerStyles: {
      background: "#7593F2",
      "font-weight": "600",
      color: "#fff",
    },
    _editConfig: {
      type: 'input',
      placeholder: 'Enter notes'
    }
  },
  {
    key: "edit",
    display_name: "",
    cellStyles: { "font-size": "13px" },
    headerStyles: {
      background: "#7593F2",
      "font-weight": "600",
      width: "3%",
      color: "#fff",
    },
    _config: {
      // displayInColumn: false,
      type: "svg-editor",
      value: "../../../../assets/images/virtusa-icons/edit-light.svg",
      isClickable: "true",
      actionType:"edit",
    },
    _editConfig: {
      type: "svg-editor",
      actionType:"add",
      value: "../../../../assets/images/virtusa-icons/tick.svg",
      isClickable: "true",
    }
  },
  {
    key: "delete",
    display_name: "",
    cellStyles: { "font-size": "13px" },
    headerStyles: {
      background: "#7593F2",
      borderRadius: "0 6px 0 0",
      "font-weight": "600",
      width: "3%",
      color: "#fff",
    },
    _config: {
      // displayInColumn: false,
      type: "svg-editor",
      value: "../../../../assets/images/virtusa-icons/delete-light.svg",
      isClickable: "true",
      actionType:"delete",
    },
    _editConfig: {
      type: "svg-editor",
      value: "../../../../assets/images/virtusa-icons/cross.svg",
      isClickable: "true",
      actionType:"cancel",
    }
  },
];
